import { FC } from 'react';
import {
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  useMediaQuery,
  Button
} from '@chakra-ui/react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { BiTransfer } from 'react-icons/bi';
import { ERC20Token } from 'types';
import { useSelectedAssets } from 'store/selectedAssets';

type Props = {
  crucibleAddress: string;
  setTabIndex: (index: number) => void;
  setTransferTabIndex: (index: number) => void;
  asset: ERC20Token;
  disabled?: boolean;
};

const UnlockedAssetsAction: FC<Props> = ({
  crucibleAddress,
  setTabIndex,
  setTransferTabIndex,
  asset,
  disabled
}) => {
  const { setSelectedCrucibleAsset } = useSelectedAssets(crucibleAddress);
  const [isLargerThan768] = useMediaQuery('(min-width: 769px)');
  const handleView = () => {
    setTabIndex(1);
    setSelectedCrucibleAsset(asset);
    setTransferTabIndex(1);
  };

  return (
    <Menu>
      {isLargerThan768 ? (
        <MenuButton
          as={IconButton}
          aria-label='Options'
          icon={<BsThreeDotsVertical />}
          variant='ghost'
          disabled={disabled}
        />
      ) : (
        <MenuButton as={Button} variant='outline' disabled={disabled}>
          Actions
        </MenuButton>
      )}
      <MenuList zIndex={4}>
        <MenuItem icon={<BiTransfer />} color='white' onClick={handleView}>
          Transfer
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default UnlockedAssetsAction;
